(ns teamoesterreich.firebase.firebase
  (:require
    [goog.object :as g]
    [teamoesterreich.config :as config]
    [teamoesterreich.util.log :as log]
    ))

(log/debug "FB App Initialized =" config/FIREBASE_CONFIG)

(defonce fb-conn js/firebase)


(def app ((g/get fb-conn "initializeApp") config/FIREBASE_CONFIG))




